// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1lC5r","image":"styles_image__zcSbh","text":"styles_text__25Rzb"};